// import URI from 'jssip/lib-es5/URI';

import { UserAgent } from './interfaces';

export const stringToUriObject = (uri: string, ua: UserAgent) => {
  const normalizedUri = ua.normalizeTarget(uri);
  //   const uriObject = new URI(
  //     normalizedUri.scheme,
  //     normalizedUri.user,
  //     normalizedUri.host,
  //     normalizedUri.port,
  //   );
  return normalizedUri;
};
